export enum ResourcesProposalImpact {
    UPDATED = 'updated',
    NEW = 'new',
}
